module.exports = __webpack_public_path__ + "static/img/jiuss.131d45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiuss.png
// module id = YNRe
// module chunks = 0